import { useMemo, type ReactNode } from "react";
import { Outlet, useParams } from "react-router-dom";
import { AppShell } from "@/components/shell/AppShell";
import { useModeratorTodoCounts } from "@/features/moderator-todo/use-moderator-todo";
import { totalWaiting } from "@/features/moderator-todo/moderator-todo";
import { useApp } from "@/hooks/use-app-context";
import { moderatorCopyFor } from "./moderator-copy";
import { buildModeratorNav, testGradingPath } from "./moderator-navigation";
import { contributionNavigation } from "@/components/shell/contribution-navigation";

export function ModeratorLayout({ children }: { children?: ReactNode } = {}) {
  const { lang = "fr" } = useParams<{ lang: string }>();
  const { t } = useApp();
  const copy = moderatorCopyFor(lang);
  const badge = totalWaiting(useModeratorTodoCounts());
  const sections = useMemo(
    () => [...buildModeratorNav(lang, copy, badge), contributionNavigation(lang, t.contribute)],
    [lang, copy, badge, t.contribute],
  );
  const base = `/${lang}/moderator`;

  return (
    <AppShell
      title={copy.space}
      homeHref={`${base}/todo`}
      sections={sections}
      extraSearchEntries={[
        { title: copy.testCorrection, href: testGradingPath(lang), icon: "checkCircle2", group: copy.todo },
        { title: copy.payouts, href: `${base}/payouts`, icon: "wallet", group: copy.todo },
        { title: copy.myPay, href: `${base}/pay`, icon: "wallet", group: copy.space },
      ]}
      accountLinks={[{ label: copy.myPay, href: `${base}/pay`, icon: "wallet" }]}
      roleLabel={t.admin.layout.roles.moderator}
      settingsHref={`${base}/profile`}
    >
      {children ?? <Outlet />}
    </AppShell>
  );
}
